/* KK24 Mystery Toy Club v2 (Figma KK-24 "v2", 2026-09-25).
   The checkbox "unlocks BOGO":
   - ON : the two picker cards are the BOGO bundles (2x / 4x). Add to cart
          sends the chosen bundle + this product's Mystery Toy Club
          subscription line (selling plan; $0 first order via "SUMMER10").
   - OFF: the same two cards become plain Buy 1 (1x) / Buy 2 (2x) of the
          regular Kitty Kurlz product (variant x qty), regular price, no club.
   Per-card data for both modes comes from the snippet (data-kk24-cards). On a
   mode switch we rewrite each card's data-* (variant, product, price, compare)
   so the theme's own picker click handler keeps working, re-sync the form and
   the price, and swap the card artwork (v2 jpgs, active/inactive per mode).
   Add to cart on this page always goes straight to /checkout. */
document.addEventListener('DOMContentLoaded', function () {
  const club = document.querySelector('[data-kk24-club]');
  if (!club) return;

  const checkbox = club.querySelector('[data-kk24-checkbox]');
  const clubVariantId = club.dataset.clubVariantId;
  const clubPlanId = club.dataset.clubPlanId;
  let cardsData = [];
  try {
    cardsData = JSON.parse(club.querySelector('[data-kk24-cards]').textContent);
  } catch (e) {
    cardsData = [];
  }

  // The sticky bundle picker renders a second add-to-cart form; the real one is
  // the one wrapped in <product-form>.
  const mainForm =
    document.querySelector('product-form form[data-type="add-to-cart-form"]') ||
    document.querySelector('form[data-type="add-to-cart-form"]');
  const priceContainer = document.querySelector('.product__info-wrapper .price__container');
  const saleEl = priceContainer && priceContainer.querySelector('.price__sale .price-item--sale');
  const compareEl = priceContainer && priceContainer.querySelector('.price__sale .price-item--regular');
  const cards = Array.prototype.slice.call(
    document.querySelectorAll('.marlenespetshop-product-bundle-custom-variant-options')
  );

  function mode() {
    return checkbox.checked ? 'on' : 'off';
  }
  function dataFor(card, m) {
    const entry = cardsData[cards.indexOf(card)];
    return entry ? entry[m || mode()] : null;
  }
  function selectedCard() {
    return cards.filter(function (c) { return c.classList.contains('selected'); })[0] || cards[0] || null;
  }

  // --- Card artwork: 4 imgs per card (on/off x active/inactive); CSS shows
  //     the right one for body.kk24-club-on + .selected/:hover. Only the pair
  //     for the initial mode loads eagerly, the rest are loading="lazy" and
  //     stay unfetched while display:none. ---
  cards.forEach(function (card, i) {
    const entry = cardsData[i];
    const wrap = card.querySelector('.product-bundle-custom-variant-image');
    if (!entry || !wrap) return;
    wrap.innerHTML = '';
    ['on', 'off'].forEach(function (m) {
      ['Active', 'Inactive'].forEach(function (state) {
        const img = document.createElement('img');
        img.src = entry[m]['img' + state];
        img.alt = '';
        img.width = 390;
        img.height = 594;
        img.className = 'kk24-card-img kk24-card-img--' + m + '-' + state.toLowerCase();
        img.loading = m === mode() ? 'eager' : 'lazy';
        wrap.appendChild(img);
      });
    });
  });

  function setPrice(sale, compare) {
    if (!saleEl) return;
    saleEl.textContent = sale;
    if (compareEl) compareEl.textContent = compare || '';
  }

  // Write the current mode's variant/price data onto every card, then push the
  // selected card into the form + the price display (the picker's own click
  // handler does this on click, but skips already-selected cards).
  function applyMode() {
    const m = mode();
    document.body.classList.toggle('kk24-club-on', m === 'on');
    cards.forEach(function (card) {
      const d = dataFor(card, m);
      if (!d || !d.variantId) return;
      card.dataset.variantId = d.variantId;
      card.dataset.productId = d.productId;
      card.dataset.bundleProductPrice = d.price;
      card.dataset.bundleComparePrice = d.compare || '';
      card.dataset.kk24Qty = d.qty;
    });
    syncForm();
  }

  function syncForm() {
    const card = selectedCard();
    if (!card) return;
    if (mainForm) {
      const idInput = mainForm.querySelector('[name="id"]');
      const pidInput = mainForm.querySelector('[name="product-id"]');
      if (idInput && idInput.value !== card.dataset.variantId) {
        idInput.value = card.dataset.variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (pidInput && pidInput.value !== card.dataset.productId) {
        pidInput.value = card.dataset.productId;
        pidInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    setPrice(card.dataset.bundleProductPrice, card.dataset.bundleComparePrice);
  }

  checkbox.addEventListener('change', function () {
    if (this.checked && !(clubVariantId && clubPlanId)) {
      this.checked = false;
      console.warn('[KK24] No selling plan on this product yet — create the Mystery Toy Club plan in the Subscriptions app.');
      return;
    }
    applyMode();
  });

  // Initial mode. setTimeout(0) so it runs after the bundle picker's own
  // DOMContentLoaded handler, which pre-selects card 1 and writes its
  // block-level price — our mode data must land after it.
  if (checkbox.checked && !(clubVariantId && clubPlanId)) checkbox.checked = false;
  setTimeout(applyMode, 0);

  // --- Add to cart -> (bundle [+ club subscription]) -> straight to checkout ---
  // Capture phase on document runs before product-form.js's own submit handler
  // (which would open the cart drawer); stopping propagation keeps it out.
  if (mainForm) {
    const btn = mainForm.querySelector('[type="submit"]');
    const spinner = btn && btn.querySelector('.loading__spinner');
    const errWrap = mainForm.parentElement && mainForm.parentElement.querySelector('.product-form__error-message-wrapper');
    const errMsg = errWrap && errWrap.querySelector('.product-form__error-message');

    function busy(on) {
      if (!btn) return;
      btn.setAttribute('aria-disabled', on ? 'true' : 'false');
      btn.classList.toggle('loading', on);
      if (spinner) spinner.classList.toggle('hidden', !on);
    }
    function showError(text) {
      if (errWrap) errWrap.toggleAttribute('hidden', !text);
      if (errMsg) errMsg.textContent = text || '';
    }

    // Coming back from checkout via the browser Back button restores the page
    // from the back/forward cache exactly as it was — with the button still in
    // its "loading" state. Reset it whenever the page is shown again.
    window.addEventListener('pageshow', function () {
      busy(false);
      showError('');
    });

    document.addEventListener(
      'submit',
      function (evt) {
        if (evt.target !== mainForm) return;
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        function fail(text, e) {
          if (e) console.error('[KK24] add to cart failed', e);
          busy(false);
          showError(text || 'Something went wrong. Please try again.');
        }

        showError('');
        busy(true);

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' };

        // 0) Replace any earlier selection from this page. Add to cart jumps
        //    straight to checkout, so a shopper who comes back and picks the
        //    other bundle would otherwise stack both bundles + 2× club.
        //    Only this page's items are removed; anything else in the cart stays.
        const kk24Updates = {};
        cardsData.forEach(function (entry) {
          ['on', 'off'].forEach(function (m) {
            if (entry[m] && entry[m].variantId) kk24Updates[entry[m].variantId] = 0;
          });
        });
        if (clubVariantId) kk24Updates[clubVariantId] = 0;

        // The form carries the selected card's variant id (applyMode / the
        // picker keep it in sync). Unticked cards are the regular product x
        // qty (1 / 2), so multiply the form quantity by the card's qty.
        const formData = new FormData(mainForm);
        const sel = dataFor(selectedCard());
        if (sel && sel.variantId) formData.set('id', String(sel.variantId));
        const cardQty = (sel && Number(sel.qty)) || 1;
        const formQty = Number(formData.get('quantity')) || 1;
        formData.set('quantity', String(cardQty * formQty));
        const cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';

        fetch(cartUpdateUrl + '.js', {
          method: 'POST',
          headers: Object.assign({ 'Content-Type': 'application/json' }, headers),
          body: JSON.stringify({ updates: kk24Updates }),
        })
          .catch(function (e) { console.warn('[KK24] cart cleanup skipped', e); })
          // 1) the bundle (whole form: id, quantity, attributes[_campaign], properties)
          .then(function () {
            return fetch(cartAddUrl, { method: 'POST', headers: headers, body: formData });
          })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'add failed');
            if (!checkbox.checked) return res;
            // 2) the Mystery Toy Club subscription line
            return fetch(cartAddUrl + '.js', {
              method: 'POST',
              headers: Object.assign({ 'Content-Type': 'application/json' }, headers),
              body: JSON.stringify({ items: [{ id: Number(clubVariantId), quantity: 1, selling_plan: Number(clubPlanId) }] }),
            })
              .then(function (r) { return r.json(); })
              .then(function (res2) {
                if (res2.status) throw new Error(res2.description || res2.message || 'club add failed');
                return res2;
              });
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (e) {
            fail(e && e.message, e);
          });
      },
      true
    );
  }

  // --- Modal carousel dots ---
  const carousel = document.querySelector('[data-kk24-carousel]');
  const dotsWrap = document.querySelector('[data-kk24-dots]');
  if (carousel && dotsWrap) {
    const cards = carousel.querySelectorAll('.kk24-drop-card');
    cards.forEach(function (dropCard, i) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        carousel.scrollTo({ left: dropCard.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });
    const dots = dotsWrap.querySelectorAll('button');
    carousel.addEventListener(
      'scroll',
      function () {
        const max = Math.max(carousel.scrollWidth - carousel.clientWidth, 1);
        const idx = Math.min(cards.length - 1, Math.round((carousel.scrollLeft / max) * (cards.length - 1)));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      },
      { passive: true }
    );
  }
});
